module.exports = __webpack_public_path__ + "img/errorImg.447954f3.png";